import { render, staticRenderFns } from "./ServiceDetailsElement.vue?vue&type=template&id=1aff0689&scoped=true&"
import script from "./ServiceDetailsElement.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsElement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailsElement.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./ServiceDetailsElement.vue?vue&type=style&index=1&id=1aff0689&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff0689",
  null
  
)

/* custom blocks */
import block0 from "../../../lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Felements%2FServiceDetailsElement.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./ServiceDetailsElement.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports